import { S, DC, ACL } from '../Utilities';

export default callback => {
    const wr = S('.main_wr');
    const b = S('body');
    const intro = DC('div', 'intro');
    b.appendChild(intro);

    setTimeout(() => {
        ACL(wr, 'show');
        ACL(intro, 'hide');
        
        callback();
    }, 500);

};